import { render, staticRenderFns } from "./PhoneFrame.vue?vue&type=template&id=6f12a020&scoped=true&"
import script from "./PhoneFrame.vue?vue&type=script&lang=js&"
export * from "./PhoneFrame.vue?vue&type=script&lang=js&"
import style0 from "./PhoneFrame.vue?vue&type=style&index=0&id=6f12a020&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f12a020",
  null
  
)

export default component.exports